import {Injectable} from '@angular/core';
import {CacheService} from "@customcoding/shared";
import {Observable} from "rxjs";
import {AppointmentColorGroup} from "../models/appointment.model";

@Injectable({
	providedIn: 'root'
})
export class AppointmentColorGroupService {

	constructor(
		private cache: CacheService,
	) { }

	getAll(): Observable<AppointmentColorGroup[]> {
		this.cache.invalidate(`/api/scap/appointment-color-group?isPaginated=0`)
		return this.getAllCached();
	}

	getAllCached(): Observable<AppointmentColorGroup[]> {
		return this.cache.get<AppointmentColorGroup[]>(`/api/scap/appointment-color-group?isPaginated=0`)
	}
}
